module.exports = __webpack_public_path__ + "static/media/storage_landing.47ee51f0.svg";